var path = 'src/app/ui/filter-helper.html';
var html = "<div class=\"filter-helper btn-group\"> <input ng-model=search placeholder=Search class=form-control /> <i class=\"fa fa-times-circle-o search-clear\" ng-click=clear()></i> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/filter-helper.html
// module id = 648
// module chunks = 0